(() => {
  // 1) HARD OVERRIDE: Prevent Sami from hiding search result prices
  // Targeted specifically for the predictive search dropdown structure
  const ensureSearchStyle = () => {
    // Unique ID to avoid conflict with your collection script
    if (document.getElementById('sami-search-price-override')) return;

    const style = document.createElement('style');
    style.id = 'sami-search-price-override';
    style.textContent = `
      /* Always show the price block in predictive search when Sami has injected wholesale data */
      .predictive-search__item-content .price[samitaws-product-price]:has(.samitaWS-customized-price):has(.samitaWS-customized-original-price) {
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
      }
    `;
    document.head.appendChild(style);
  };

  // 2) JS SAFETY: Fixes the DOM nodes when search results load via AJAX
  const fixSearchWholesalePrice = () => {
    ensureSearchStyle();

    // Target the specific container class from your predictive-search.liquid
    document
      .querySelectorAll('.predictive-search__item-content .price[samitaws-product-price]')
      .forEach((priceEl) => {
        const hasWholesale = !!priceEl.querySelector('.samitaWS-customized-price');
        const hasCompareAt = !!priceEl.querySelector('.samitaWS-customized-original-price');

        // Only act if Sami rule applied AND compare-at exists
        if (!hasWholesale || !hasCompareAt) return;

        // Remove Sami inline hide if present
        if (priceEl.style?.display === 'none') priceEl.style.removeProperty('display');

        // Force visible
        priceEl.style.setProperty('display', 'block', 'important');
        priceEl.style.setProperty('visibility', 'visible', 'important');
        priceEl.style.setProperty('opacity', '1', 'important');
      });
  };

  // Tiny debounce to handle rapid typing/DOM updates
  let raf = null;
  const scheduleFix = () => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = null;
      fixSearchWholesalePrice();
    });
  };

  // Run when Sami app signals it has finished processing prices
  window.addEventListener('samitaWSRenderWholesaleCompleted', () => {
    fixSearchWholesalePrice();
    // Extra timeouts are crucial for search because elements are created dynamically
    setTimeout(fixSearchWholesalePrice, 50);
    setTimeout(fixSearchWholesalePrice, 200);
    setTimeout(fixSearchWholesalePrice, 600);
  });

  // Run on page load (just in case)
  document.addEventListener('DOMContentLoaded', () => {
    fixSearchWholesalePrice();
  });

  // Watch for the search results container being added/changed in the DOM
  const mo = new MutationObserver(scheduleFix);
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Initial
  fixSearchWholesalePrice();
})();